<ng-template #sharedContent>
    <div fxFlex fxLayout="column" class="icons-panel" [ngClass]="{'dialog-mode': isDialog}">
        <div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 0 5px;">
            <mat-form-field class="filter">
                <mat-label>{{ 'general.filter' | transloco }}</mat-label>
                <input matInput inputrestriction="basic1" autocomplete="off" [(ngModel)]="filter" (ngModelChange)="applyFilter()">
                <a matSuffix aria-label="Clear" (click)="clearFilter()">
                    <mat-icon>close</mat-icon>
                </a>
            </mat-form-field>
            <a mat-icon-button class="mini-button" style="opacity: 0.8;" (click)="blockSmallView = !blockSmallView">
                @if (!blockSmallView) {
                    <span matTooltip="{{'general.toggleSmallView' | transloco}}">
                        <svg viewBox="0 0 448 512" class="svg-inline--fa fa-grid-2 fa-lg">
                            <path fill="currentColor" 
                                d="M192 80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
                                class="">
                            </path>
                        </svg>
                    </span>
                } @else {
                    <mat-icon matTooltip="{{'general.toggleLargeView' | transloco}}">apps</mat-icon>
                }
            </a>
        </div>
        @if (iconList && iconList.length > 0) {
              <div
                 class="icons-wrapper"
                id="stickList"
                infinite-scroll
                [scrollWindow]="false"
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="throttle"
                (scrolled)="loadMoreIcons()">

                <div class="icon-grid" 
                    cdkDropList
                    cdkDropListSortingDisabled
                    [cdkDropListData]="iconList"
                    (cdkDropListDropped)="dropIcon($event)">
            
                    @for(icon of iconList; track icon) {
                        <div class="icon-item" [cdkDragData]="icon" cdkDrag (click)="selectIcon(icon)">
                            <mat-icon [ngClass]="{'size-sm': blockSmallView, 'size-lg': !blockSmallView}" [matTooltip]="getTooltip(icon)">{{icon}}</mat-icon>
                        </div>
                    }
                </div>
            </div>
        } @else {
            <div class="no-icons">
                <mat-icon>face</mat-icon>&nbsp;{{'general.noIconsFound' | transloco}}
            </div>
        }
    </div>
</ng-template>


<!-- Render inline if not a dialog -->
@if (!isDialog) {
    <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
} @else {
    <mat-dialog-content>
        <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button (click)="closeDialog()">Close</button>
    </mat-dialog-actions>
}
